
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MemberTodoEntry.html?raw';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import "../../../moreCore/UI/DateInput/DateInput";
import "../../../moreCore/UI/StaticTable/StaticTable";
import { TodoListTypes } from "../../_loadingHelpers/TodoList"
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import Tooltip from '../../../moreCore/UI/Floating/Tooltip';
import { ToasterHelpers } from "../../../more/Helpers";
class MemberTodoEntry extends compose(_StatefulSection, _TabEnabledMixin) {
    templateString: any = template;

    sourceClass: HTMLSpanElement;
    memberName: HTMLSpanElement;

    //private entityId: string = null;
    private cbIsFinished: MdsLax<InstanceType<typeof CheckBox>>;
    private descriptionTooltipContainer: HTMLElement;

    private entityData: TodoListTypes.TodoMemberEntity = null;

    afterSetData() {
        let data = this.sourceData as TodoListTypes.TodoMemberEntity;

        this.entityId = data.ID;

        
        this.cbIsFinished.setLabel(data.task_description ? data.task_description : data.parent_task_description);

        let tooltip = new Tooltip();

        tooltip.setup({
            content: data.note,
            heading: this.cbIsFinished.getLabel(),
            targetnode: this.descriptionTooltipContainer,
            enableClick: true
        });

        this.UiModder.domConstruct.empty(this.sourceClass);
        switch (data.Classname) {
            case "todo_member_evis_user":
                this.UiModder.domConstruct.place(this.createFontawesomeIcon("fas fa-user w3-text-green"), this.sourceClass);
                this.memberName.textContent = data.memberName;
                break;

            case "todo_member_associate_grouped":
                this.UiModder.domConstruct.place(this.createFontawesomeIcon("fas fa-users w3-text-blue-gray"), this.sourceClass);
                this.memberName.textContent = data.groupName;
                break;
        }

        this._setDataBasedStyle();
    }

    private _setDataBasedStyle() {
        let data = this.currentData as TodoListTypes.TodoMemberEntity;
        let currentEmployeeId = window.sessionInfo?.sessionData?.CurrentEmployeeId;
        let isAllowedToModify: boolean;

        switch (data.Classname) {
            case "todo_member_evis_user":
                isAllowedToModify = data.memberID == currentEmployeeId;
                break;
            case "todo_member_associate_grouped":
                isAllowedToModify = data.is_in_group;
                break;
            default:
                isAllowedToModify = false;
        }

        this.hideNode(this.descriptionTooltipContainer, !(data.note && isAllowedToModify))

        this.cbIsFinished.setReadonly(!isAllowedToModify);

        this.UiModder.domClass.toggle(this.cbIsFinished.domNode, "strike", data.is_finished === true);

        if (isAllowedToModify) {
            this.UiModder.domClass.toggle(this.domNode, "border accentBorder accentTransparentBG", data.is_finished !== true);
        } else {
            this.UiModder.domClass.toggle(this.domNode, "border secondaryBorder", true);
        }
    }

    private _onClickDescription(evt: MouseEvent) {
        //evt.stopPropagation();

        //let data = this.sourceData as TodoListTypes.TodoMemberEntity;

        //let tooltip = new Tooltip();

        //tooltip.setup({
        //    content: data.note,
        //    heading: this.cbIsFinished.getLabel(),
        //    targetnode: this.descriptionTooltipContainer,
        //    enableClick: true
        //});

        
    }

    private _saveTimeoutHandle: any = null;
    protected onDirtyChange(newState: boolean) {
        console.log(this.id + " dirtyChange", newState, this.currentData);

        if (newState == true) {
            this.saveData();
        }
    }

    private saveData(): void {

        if (this._saveTimeoutHandle) {
            clearTimeout(this._saveTimeoutHandle);
        }

        this._saveTimeoutHandle = setTimeout(lang.hitch(this, this._save), 100);
    }

    private _save(): void {

        this.StandbyStart();

        let data = {
            "todoMemberID": this.entityId,
            ...this.changedData
        };

        this.RequestManager.post(
            window.appRoot + "TodoList/SaveTodoMemberEntity",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onSaveData_Response),
            lang.hitch(this, this._onSaveData_Error)
        );

    }


    private _onSaveData_Response(response): void {
        //this.StandbyStop();
        this.resetDirty();

        this.emit("saved", true);

        this.StandbyStop();

        this.showToast({
            title: this.translations["General__SaveSuccess"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

    }

    private _onSaveData_Error(error: more.requestErrorMessage) {
        this.StandbyStop();

        this.showToast({
            title: this.translations["General__ProcessFailed"],
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message
        });

        this.rollback();
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MemberTodoEntry);